module.exports = __webpack_public_path__ + "img/poly-6.27ec3914.png";